import React from 'react';
import { Star } from 'lucide-react';

const RatingDisplay = ({ 
  rating, 
  totalRatings = 0, 
  showCount = true, 
  size = "sm",
  showStars = true,
  className = ""
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case "xs":
        return "text-xs";
      case "sm":
        return "text-sm";
      case "md":
        return "text-base";
      case "lg":
        return "text-lg";
      case "xl":
        return "text-xl";
      default:
        return "text-sm";
    }
  };

  const getStarSize = () => {
    switch (size) {
      case "xs":
        return "w-3 h-3";
      case "sm":
        return "w-4 h-4";
      case "md":
        return "w-5 h-5";
      case "lg":
        return "w-6 h-6";
      case "xl":
        return "w-7 h-7";
      default:
        return "w-4 h-4";
    }
  };

  const renderStars = () => {
    if (!showStars || rating === null || rating === undefined) return null;
    
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <Star 
          key={i} 
          className={`${getStarSize()} fill-yellow-400 text-yellow-400`} 
        />
      );
    }
    
    // Half star
    if (hasHalfStar) {
      stars.push(
        <div key="half" className="relative">
          <Star className={`${getStarSize()} text-gray-300`} />
          <Star 
            className={`${getStarSize()} fill-yellow-400 text-yellow-400 absolute top-0 left-0 overflow-hidden`}
            style={{ width: '50%' }}
          />
        </div>
      );
    }
    
    // Empty stars
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <Star 
          key={`empty-${i}`} 
          className={`${getStarSize()} text-gray-300`} 
        />
      );
    }
    
    return stars;
  };

  const formatRating = (rating) => {
    if (rating === null || rating === undefined) return "No ratings";
    return rating.toFixed(1);
  };

  const formatCount = (count) => {
    if (count === 0) return "No ratings";
    if (count === 1) return "1 rating";
    return `${count} ratings`;
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showStars && (
        <div className="flex items-center gap-0.5">
          {renderStars()}
        </div>
      )}
      <span className={`${getSizeClasses()} font-semibold ${className || 'text-white/80'}`}>
        {formatRating(rating)}
        {showCount && totalRatings > 0 && (
          <span className="ml-1">({formatCount(totalRatings)})</span>
        )}
      </span>
    </div>
  );
};

export default RatingDisplay;
